import React from 'react';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_DATABASE } from '../../../../constants/connectionCategories';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_SINK_REQUEST } from 'js/constants/actionTypes';

const DatabaseSinkConfiguration = (props) => {
  const isLoadingResource = useIsLoading(GET_SINK_REQUEST);
  return (
    <ConfigurationFields
      {...props}
      isLoadingResource={isLoadingResource}
      connectionCategory={CONNECTION_CATEGORY_DATABASE}
    />
  );
};

export default DatabaseSinkConfiguration;
